// extracted by mini-css-extract-plugin
export default {"sm":"StatusBadge_sm_CBvVL"};